<template>
  <l-map :zoom="zoom" :center="center" ref="refmap">
    <l-tile-layer :url="url"></l-tile-layer>
    <l-marker v-for="marker in markers"
              :key="marker.id"
              :lat-lng="marker.coordinates">
      <l-popup>
        <span v-html="marker.popup"></span>
      </l-popup>
    </l-marker>
  </l-map>
</template>

<script>
import {LMap, LMarker, LPopup, LTileLayer} from 'vue2-leaflet';
import moment from "moment/moment";

export default {
  name: "Map",
  props: ['devices', 'zoom'],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  watch: {
    devices: () => {
      this.setMarkers()
    }
  },
  data: () => ({
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    center: [46.074499618460166, 11.121769612984918],
    markers: []
  }),
  created() {
    // Serve perché ci sono problemi tra il modale e la mappa per il dimensionamento
    setTimeout(() => {
      this.$refs.refmap.mapObject.invalidateSize();
    }, 100);

    this.setMarkers()
  },
  methods: {
    setMarkers() {
      if (this.devices.length === 1) this.center = [this.devices[0].latitude, this.devices[0].longitude]

      this.devices.forEach((item, index) => {
        this.markers.push({
          id: index,
          popup: this.popupMessage(item),
          coordinates: [item.latitude, item.longitude]
        })
      })
    },
    popupMessage(tablet) {
      let locatedAt = this.localFormat(tablet.locatedAt)
      return `<strong>Tablet n</strong>: ${tablet.ordinalNumber}<br><strong>Negozio:</strong> ${tablet.shop}<br><strong>Ultima posizione rilevata</strong>: ${locatedAt}`
    },
    localFormat: date => moment(date).local().format("DD/MM/YYYY HH:mm"),
  }
}
</script>

<style>
</style>
